import { atom } from "recoil";
import { recoilPersist } from "recoil-persist";

const { persistAtom } = recoilPersist({
  key: "microbiologyReportPersistedState", // storage key
  storage: localStorage, // or sessionStorage
});
const getFormattedCurrentDate = () => {
  const today = new Date();
  const day = today.getDate();
  const month = today.toLocaleString("en-US", { month: "long" });
  const year = today.getFullYear();
  const formattedDay = day < 10 ? `0${day}` : day;

  return `${month} ${formattedDay}, ${year}`;
};
const getFormattedDate = () => {
  const today = new Date();
  return today.toISOString().split("T")[0];
};

export const microbiologyReportsLoadedState = atom({
  key: "microbiologyReportsLoadedState",
  default: false,
});

export const microbiologyReportState = atom({
  key: "microbiologyReportState",
  default: [],
});

export const rowLoadingState = atom({
  key: "microbiologyRowLoadingState",
  default: false,
});

export const formattedFromDateState = atom({
  key: "microbiologyFormattedFromDateState",
  default: getFormattedCurrentDate(),
  effects_UNSTABLE: [persistAtom],
});

export const formattedToDateState = atom({
  key: "microbiologyFormattedToDateState",
  default: getFormattedCurrentDate(),
  effects_UNSTABLE: [persistAtom],
});

export const fromDateState = atom({
  key: "microbiologyFromDateState",
  default: getFormattedDate(),
  effects_UNSTABLE: [persistAtom],
});

export const toDateState = atom({
  key: "microbiologyToDateState",
  default: getFormattedDate(),
  effects_UNSTABLE: [persistAtom],
});
